import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

const Legend = ({ data }) => {
    return (
        <View style={styles.legendContainer}>
            {data.map((item,index) => (
                <View key={index} style={styles.legendItem}>
                    <View style={[styles.legendColor, { backgroundColor: item?.color }]} />
                    <Text style={styles.legendLabel}>{item.label}</Text>
                </View>
            ))}
        </View>
    );
};

const styles = StyleSheet.create({
    legendContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 20,
    },
    legendItem: {
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 10,
        marginBottom: 5,
    },
    legendColor: {
        width: 15,
        height: 15,
        marginRight: 5,
        borderRadius: 7.5,
    },
    legendLabel: {
        fontSize: 14,
    },
});

export default Legend;